import Marquee from "react-fast-marquee";
import { Star, Quote } from "lucide-react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/i18n";

const PHOTOS = [
  "https://images.unsplash.com/photo-1544725176-7c40e5a71c5e",
  "https://images.unsplash.com/photo-1757744705465-ea08b0ddc38a",
  "https://images.pexels.com/photos/6950702/pexels-photo-6950702.jpeg",
  "https://images.unsplash.com/photo-1757744705465-ea08b0ddc38a",
  "https://images.unsplash.com/photo-1544725176-7c40e5a71c5e",
];

function Card({ t, photo }) {
  return (
    <div
      className="mc-card w-[360px] sm:w-[420px] p-8 mx-3 flex flex-col justify-between"
      data-testid={`testimonial-card-${t.name.toLowerCase().replace(/\s/g, "-")}`}
    >
      <div>
        <Quote className="h-7 w-7 text-[color:var(--mc-cyan)] opacity-80" />
        <p className="mt-5 text-white/85 leading-relaxed">“{t.text}”</p>
      </div>
      <div className="mt-7 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img src={photo} alt={t.name} className="h-12 w-12 rounded-full object-cover border border-white/15" />
          <div>
            <p className="font-heading font-semibold text-sm text-white">{t.name}</p>
            <p className="text-xs text-white/55">{t.location}</p>
          </div>
        </div>
        <div className="flex items-center gap-0.5">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} className="h-4 w-4 fill-[color:var(--mc-gold)] text-[color:var(--mc-gold)]" />
          ))}
        </div>
      </div>
    </div>
  );
}

export default function TestimonialsMarquee() {
  const { tr } = useI18n();
  const items = tr.testimonials.items.map((t, i) => ({ ...t, photo: PHOTOS[i % PHOTOS.length] }));

  return (
    <section className="py-24 lg:py-32 relative" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <p className="overline text-[color:var(--mc-gold)]">{tr.testimonials.overline}</p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="font-serif-display text-4xl sm:text-5xl font-semibold tracking-tight mt-4 leading-tight text-white"
          >
            {tr.testimonials.title_pre}{" "}
            <em className="not-italic italic bg-gradient-to-r from-[color:var(--mc-cyan-2)] to-[color:var(--mc-cyan)] bg-clip-text text-transparent">
              {tr.testimonials.title_em}
            </em>
          </motion.h2>
          <p className="mt-5 text-white/70 text-lg leading-relaxed">{tr.testimonials.subtitle}</p>
        </div>
      </div>

      <div className="fade-sides">
        <Marquee gradient={false} speed={38} pauseOnHover className="py-4">
          {items.map((t, i) => (<Card key={i} t={t} photo={t.photo} />))}
        </Marquee>
        <Marquee gradient={false} speed={32} direction="right" pauseOnHover className="py-4 mt-3">
          {items.slice().reverse().map((t, i) => (<Card key={`r-${i}`} t={t} photo={t.photo} />))}
        </Marquee>
      </div>
    </section>
  );
}
